export const packageIds = {
  subOrgs: 7,
  basicPackage: 37,
  subOrgsVideo: 135,
};
